import React, { useRef, useEffect } from "react";

import { measurerGraphNavAdapter } from "./measurer-graph-nav-adapter";

import VisualizatorSettings from "./VisualizatorSettings.json";
import { prepareSplitHOC } from "../../../../../hoc/prepareSplitHOC";

const graphWrapStyle = {
    height: "100%",
    width: "100%",
    position: "relative",
    backgroundColor: "white"
};

const MeasurerGraphNav = props => {
    const canvasRef = useRef(null);
    const graphAdapter = useRef(null);
    const isMounted = useRef(false);
    const latestProps = useRef(props);
    const {
        signalData,
        signalStart,
        mainGraphWidth,
        fd,
        setNavGraphWidth,
        refreshFlag,
        userSweepUnits,
        signalRhythmStart,
        setSignalRhythmStart
    } = props;

    useEffect(() => {
        const mount = async () => {
            graphAdapter.current = new measurerGraphNavAdapter({
                canvasRef: canvasRef.current,
                visualSettings: VisualizatorSettings,
                fd: fd
            });

            graphAdapter.current.changeDefaultFrequencySettungs(fd);
            await graphAdapter.current.initializeGraph();
            await graphAdapter.current.setupRectangles();
            graphAdapter.current.setUserSweepUnits(userSweepUnits);

            const graphWidth = graphAdapter.current.getWidthInPoints(fd);
            setNavGraphWidth(graphWidth);
            graphAdapter.current.onResize(onResize);

            isMounted.current = true;
        };

        mount();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const update = async () => {
            if (signalData.length && mainGraphWidth) {
                Promise.all([updateGraph(), updateAreaRectnalge(), updateSelectRectangle()]);
            }
        };

        update();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signalData, mainGraphWidth, refreshFlag]);

    useEffect(() => {
        if (isMounted.current) {
            graphAdapter.current.setUserSweepUnits(userSweepUnits);
        }
    }, [userSweepUnits]);

    useEffect(() => {
        latestProps.current = props;
    });

    const updateGraph = async () => {
        await Promise.all([graphAdapter.current.clearGraph()]);
        await graphAdapter.current.plotData(signalData);
    };

    const updateSelectRectangle = () => {
        const { Q, S, fd } = props;
        const start = Q - 0.25 * fd - signalRhythmStart;
        const end = S + 0.25 * 2 * fd;

        graphAdapter.current.moveSelectRectangle(start, end + 1);
    };

    const updateAreaRectnalge = () => {
        const { signalLength } = props;

        let newStart = signalStart;
        const proposedEnd = signalStart + mainGraphWidth;

        if (proposedEnd > signalLength) {
            newStart = signalLength - mainGraphWidth;
        }

        if (signalRhythmStart !== 0) {
            newStart = newStart % signalRhythmStart;
        }

        newStart = Math.max(0, newStart);

        graphAdapter.current.moveAreaRectangle(newStart, mainGraphWidth);
    };

    const onResize = async () => {
        const { signalStart, mainGraphWidth } = latestProps.current;

        const graphWidth = graphAdapter.current.getWidthInPoints(fd);
        setNavGraphWidth(graphWidth);
        // Calculate adjustment coeff for mainGraphWidth windows shrinking due to resize
        const sm = graphAdapter.current.valueConverter.convertMmToPoints(2, fd);
        setSignalRhythmStart(Math.floor(signalStart / (graphWidth - mainGraphWidth + sm)) * (graphWidth - mainGraphWidth + sm));
    };

    return <div className="canvas-wrap" style={graphWrapStyle} ref={canvasRef} />;
};

export default prepareSplitHOC(MeasurerGraphNav);
